<template>
  <div class="ts-overflow-auto">
    <table class="ts-w-full">
      <thead>
        <tr class="ts-bg-gray-300">
          <td
            class="ts-px-4 ts-py-1 ts-text-center ts-uppercase "
            style="border: 1px solid rgba(49, 130, 206); padding: 3px 10px;"
            v-for="(sub, index) in headerTable"
            :colspan="countSpan(sub.id)"
          >
            {{ sub[$i18n.locale] }}
          </td>
        </tr>
        <tr style="border: 1px solid rgba(49, 130, 206); ">
          <td
            class="ts-px-4 ts-text-center"
            style="border: 1px solid rgba(49, 130, 206); padding: 0 10px;"
            v-for="(rec, subIndex) in record"
          >
            <p class="ts-py-0">{{ rec.comp_item_name }}</p>
            <p class="ts-py-0 ts-text-blue-700 ts-font-semibold">{{ rec.actual_score }}</p>
          </td>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
const getUniqueValues = array => {
  const uniqueMap = new Map()
  array.forEach(item => uniqueMap.set(item.id, item))
  return Array.from(uniqueMap.values())
}

export default {
  name: 'detailInTableList',
  props: ['record'],
  data() {
    return {}
  },
  computed: {
    headerTable() {
      if (this.record !== undefined) {
        const result = this.record.map(el => ({
          kh: el.subject_name_native,
          en: el.subject_name_foreign,
          id: el.sc_subject_id
        }))

        return getUniqueValues(result)
      }
      return []
    },
    countSpan: vm => subjectId => {
      return vm.record.filter(s => s.sc_subject_id === subjectId).length
    }
  }
}
</script>
